<template>
  <text-field-date-picker
    v-model="claim.date"
    :label="$t('commonStrings.date')"
    :allowed-dates="allowedDates"
    :disabled="disabled"
    @input="resetClaim(claim)"
  />
</template>

<script>
import TextFieldDatePicker from "@/views/common/components/TextFieldDatePicker";

export default {
  name: "ClaimDatePicker",
  components: {
    TextFieldDatePicker
  },
  props: {
    claim: {
      type: Object,
      required: true
    },
    allowedDates: Function,
    disabled: Boolean
  },
  methods: {
    resetClaim(claim) {
      delete claim["payingOrgs"];
      delete claim["claimTypeId"];

      this.$emit("claim-date-change");
    }
  }
};
</script>